import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarRange } from "lucide-react";

export const SeasonSelect = ({ value, options, current, onChange, testid = "materials-season-select", compact, withAll = true }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={compact ? "h-7 w-[92px] text-xs" : "w-full sm:w-[240px]"} data-testid={testid} onClick={(e) => e.stopPropagation()}>
      {!compact && <CalendarRange className="mr-2 h-4 w-4 text-primary" />}
      <SelectValue placeholder="Stagione" />
    </SelectTrigger>
    <SelectContent onClick={(e) => e.stopPropagation()}>
      {withAll && <SelectItem value="tutti" data-testid={`${testid}-tutti`}>Tutte le stagioni</SelectItem>}
      {value && value !== "tutti" && !options.includes(value) && <SelectItem value={value}>{value}</SelectItem>}
      {options.map((s) => (
        <SelectItem key={s} value={s} data-testid={`${testid}-${s.toLowerCase()}`}>{compact ? s : `Stagione ${s}`}{s === current && !compact ? " (corrente)" : ""}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
